export function fetchLocks(idSeason) { return { type: 'LOCKS/FETCH', idSeason } }
export function addLock(lock) { return { type: 'LOCKS/ADD', lock } }
export function deleteLockSchedule(index, IdTeamUserRoleLock) { return { type: 'LOCKS/DELETE', index, IdTeamUserRoleLock } }
export function saveLock(lock) { return { type: 'LOCKS/SAVE', lock } }
export function updateLock(lock) { return { type: 'LOCKS/UPDATE', lock } }